
import React from 'react';

const WhyLicenseSection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2A6041] mb-4">なぜ資格が必要か</h2>
          <p className="text-xl sm:text-lg text-gray-600">DJI農業ドローン運用における民間資格の重要性</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-gray-50 rounded-2xl p-8 shadow-lg h-full flex flex-col min-h-[350px]">
            <div className="w-16 h-16 bg-[#76B947]/10 rounded-full flex items-center justify-center mb-6">
              <i className="ri-shield-check-line text-3xl text-[#76B947]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#2A6041] mb-4">業界標準の技能証明</h3>
            <div className="flex-1">
              <p className="text-gray-600 text-lg leading-relaxed mb-4">
                農業ドローン協議会の民間資格は、DJI農業ドローン運用における業界標準の技能証明です。
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                  <span>農薬散布業務の安全な実施</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                  <span>法令遵守の正しい知識</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                  <span>機体の適切な操作技術</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                  <span>緊急時の対応能力</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 shadow-lg h-full flex flex-col min-h-[350px]">
            <div className="w-16 h-16 bg-[#76B947]/10 rounded-full flex items-center justify-center mb-6">
              <i className="ri-building-line text-3xl text-[#76B947]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#2A6041] mb-4">信頼性と責任の証明</h3>
            <div className="flex-1">
              <p className="text-gray-600 text-lg leading-relaxed mb-4">
                資格取得により、農業従事者としての専門性と責任感を対外的に証明できます。
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                  <span>顧客・取引先への信頼性向上</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                  <span>保険加入時の優遇措置</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                  <span>補助金申請での有利性</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                  <span>事故時の責任範囲明確化</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyLicenseSection;
